<script setup lang="ts">
import type {
  ReviewWidgetBundle,
} from '@thehotelsnetwork/personalization-types';
import {
  ActionButton,
  Modal,
  useTheme,
  useComputedSettings,
} from '@thehotelsnetwork/widgets-core';

import MainRating from '../components/MainRating.vue';
import ReviewList from '../components/ReviewList.vue';

import {
  useTailwindTheme,
} from '../composables';

const props = defineProps<{
  config: ReviewWidgetBundle;
}>();

const emit = defineEmits([
  'close',
]);

const theme = useTheme();
const tailwindTheme = useTailwindTheme();
const computedSettings = useComputedSettings();

function close() {
  emit('close');
}

</script>

<template>
  <Modal
    :show-close="false"
    :z-index="computedSettings.tooltipZIndex"
    :class="[
      'w-full sm:w-3/4 md:w-4/6 xl:w-1/2 max-w-[640px] max-h-[80vh] min-h-[26rem] flex flex-col root',
      { rtl: props.config.isRightAlign },
    ]"
    @close="close"
  >
    <div class="reviews-header">
      <MainRating
        :data="props.config.payload.reviewAverages"
        :colors="{
          darkText: tailwindTheme.colors.grey[900],
          lightText: tailwindTheme.colors.grey[500],
        }"
        orientation="horizontal"
        class="flex-1"
      />
      <ActionButton
        type="close"
        :over-color="theme.backgroundColor.base"
        @action-click="close"
        data-testid="close-modal"
      />
    </div>
    <ReviewList
      :reviews="props.config.payload.reviews"
    />
  </Modal>
</template>

<style scoped>
.reviews-header {
  display: flex;
  align-items: center;
  background-color: v-bind('theme.backgroundColor.washed');
  padding-block: 12px;
  padding-inline-end: 12px;
  padding-inline-start: 32px;
  gap: 16px;
}
</style>
